import styled from 'styled-components';

export const GridRow = styled.div`
  width: 100%;
  background-color: #525252;
`;

export const GridFlex = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${({reverse}) => (reverse ? 'row-reverse' : 'row')};

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const GridImage = styled.div`
  width: 50%;
  height: 100%;
  position: absolute;
  ${({reverse}) => (reverse ? 'left: 0' : 'right: 0')};
  top: 0;
  background-image: url(${({backgroundImage}) => backgroundImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const GridMobileImage = styled.img`
  width: 100%;
  height: auto;
  display: none;

  @media (max-width: 1024px) {
    display: block;
  }
`;

export const GridInfo = styled.div`
  padding: 70px;
  width: 50%;
  background-color: #525252;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 40px;
  }

  @media (max-width: 768px) {
    padding: 20px;
  }
`;
